import { render, staticRenderFns } from "./DropdownListItem.vue?vue&type=template&id=b08fdb3a&functional=true"
import script from "./DropdownListItem.vue?vue&type=script&lang=js"
export * from "./DropdownListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports